import script from "./ViewChips.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewChips.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__